import type { QuizGroupAssociation } from '@/types/quizSet'

export const ALL_ASSOCIATION_SOURCES = '__all__'
export const UNSPECIFIED_ASSOCIATION_SOURCE = '__unspecified__'

export interface AssociationSourceSummary {
  key: string
  label: string
  associationCount: number
  itemCount: number
}

export function getAssociationSourceKey(association: QuizGroupAssociation): string {
  const source = association.sourceSystem?.trim() || association.group.sourceSystem?.trim()
  return source || UNSPECIFIED_ASSOCIATION_SOURCE
}

export function getAssociationSourceLabel(sourceKey: string): string {
  if (sourceKey === 'qb_aiq') return 'AIQ'
  if (sourceKey === 'legacy_ttaedaeggae' || sourceKey === 'legacy_aiq') return '따대깨'
  return sourceKey === UNSPECIFIED_ASSOCIATION_SOURCE ? '출처 없음' : sourceKey
}

export function summarizeAssociationSources(
  associations: QuizGroupAssociation[],
): AssociationSourceSummary[] {
  const summaries = new Map<string, AssociationSourceSummary>()
  for (const association of associations) {
    const key = getAssociationSourceKey(association)
    const current = summaries.get(key)
    if (current) {
      current.associationCount += 1
      current.itemCount += association.group.items.length
      continue
    }
    summaries.set(key, {
      key,
      label: getAssociationSourceLabel(key),
      associationCount: 1,
      itemCount: association.group.items.length,
    })
  }
  return Array.from(summaries.values()).sort((left, right) => {
    if (left.key === UNSPECIFIED_ASSOCIATION_SOURCE) return 1
    if (right.key === UNSPECIFIED_ASSOCIATION_SOURCE) return -1
    return left.label.localeCompare(right.label, 'en')
  })
}

export function filterAssociationsBySource(
  associations: QuizGroupAssociation[],
  sourceKey: string,
): QuizGroupAssociation[] {
  if (sourceKey === ALL_ASSOCIATION_SOURCES) return associations
  return associations.filter((association) => getAssociationSourceKey(association) === sourceKey)
}
